import { defineMessages } from 'react-intl';

export const articleServicesMessages = defineMessages({
  articleServicesCardHeadline: {
    id: 'article.services.card.headline',
    defaultMessage: 'Services jetzt dazu bestellen',
  },
  articleServicesCardTip: {
    id: 'article.services.card.tip',
    defaultMessage: 'Tipp',
  },
  articleServicesMoreInfo: {
    id: 'article.services.more.text',
    defaultMessage: 'Mehr Info',
  },
  articleServicesInclusive: {
    id: 'article.services.inclusive',
    defaultMessage: 'inklusive',
  },
  articleServicesFree: {
    id: 'article.services.free',
    defaultMessage: 'gratis',
  },
});
